<script setup lang="ts">
import type { TagsInputItemDeleteProps } from 'radix-vue'
import type { HTMLAttributes } from 'vue'
import { X } from 'lucide-vue-next'
import { TagsInputItemDelete, useForwardProps } from 'radix-vue'
import { computed } from 'vue'
import { cn } from '~/helpers'

const props = defineProps<TagsInputItemDeleteProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <!-- <TagsInputItemDelete v-bind="forwardedProps" :class="cn('flex rounded bg-transparent mr-1 absolute right-0 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 group-active:opacity-100 transition-opacity backdrop-blur-md', props.class)"> -->
  <TagsInputItemDelete v-bind="forwardedProps" :class="cn('flex rounded bg-transparent mr-1', props.class)">
    <slot>
      <X class="w-4 h-4" />
    </slot>
  </TagsInputItemDelete>
</template>
